module.exports = __webpack_public_path__ + "static/media/Corrosion.a661f44f.png";